module.exports = __webpack_public_path__ + "static/media/b-double.e47b753a.svg";